import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import CertificateAudition from "./CertificateAudition";
import swal from "sweetalert";
import LoaderPost from "../../../../../../../Reuseable/LoaderPost";

const CreateCertificate = () => {
  const [convertedContent, setConvertedContent] = useState("");
  const [file, setFile] = useState("");
  const [errorList, setErrorList] = useState([]);
  const [auditionId, setAuditionId] = useState("");
  const [frame, setFrame] = useState("");
  const [logo, setLogo] = useState("");
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [logoData, setLogoData] = useState("");
  const [frameData, setFrameData] = useState("");
  const [fileData, setFileData] = useState("");
  const [event, setEvent] = useState({});
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fee, setFee] = useState("");

  const [loader, setLoader] = useState(false);

  const handleSubTitle = (e) => {
    setSubTitle(e.target.value);
  };
  const handleTitle = (e) => {
    setTitle(e.target.value);
  };
  const handleImageChange = (file) => {
    setFile(URL.createObjectURL(file[0]));
    setFileData(file[0]);
  };
  const handleBannerLogo = (file) => {
    setLogo(URL.createObjectURL(file[0]));
    setLogoData(file[0]);
  };
  const handleFrame = (file) => {
    setFrame(URL.createObjectURL(file[0]));
    setFrameData(file[0]);
  };

  const submitCertificate = (e) => {
    e.preventDefault();
    setLoader(true);
    const fData = new FormData();

    fData.append("audition_id", auditionId);
    fData.append("title", title);
    fData.append("sub_title", subTitle);
    fData.append("main_content", convertedContent);
    fData.append("frame", frameData);
    fData.append("brand_logo", logoData);
    fData.append("company_logo", fileData);
    fData.append("fee", fee);
    // const data = {
    //   audition_id: auditionId,
    //   title: title,
    //   sub_title: subTitle,
    //   main_content: convertedContent,
    //   frame: frameData,
    //   brand_logo: logoData,
    //   company_logo: fileData,
    // };

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(
          `/api/audition-admin/audition/make-certificate/${auditionId}`,
          fData
        )

        .then((res) => {
          setLoader(false);
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
          }
        });
    });
  };
  const handleChange = (event) => {
    setAuditionId(event.target.value);
  };
  useEffect(() => {
    fetchAuditions();
  }, []);
  const fetchAuditions = () => {
    axios.get(`/api/audition-admin/audition/events`).then((res) => {
      if (res.data.status === 200) {
        setEvents(res.data.events);
        // setLoading(false);
      }
    });
  };
  useEffect(() => {
    setLoading(false);
    var result = events.find((item) => item.id == auditionId);
    setEvent(result);
  }, [auditionId]);

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <div className="container-lg">
          <CertificateAudition />

          <div className="row mx-1">
            <h4 className="tITLES py-2 mb-3">Certificate Content</h4>
            <div
              className="card ReImg "
              style={{
                backgroundImage:
                  "url(https://cdn.pixabay.com/photo/2021/09/02/16/48/cat-6593947_960_720.jpg)",
              }}
            ></div>
          </div>

          <div className="row mx-1 mt-3">
            <h3 className="card top3 text-center fw-bold py-2">
              <i>Create Certificate Content</i>
            </h3>
          </div>

          <div className="row mx-1">
            <div className="bg-dark">
              <form onSubmit={submitCertificate}>
                <div className="form-group row justify-content-center my-3">
                  <label
                    for="Audition"
                    className="col-sm-3 text-warning fw-bold"
                  >
                    Audition Logo
                  </label>
                  <div className="form-group row d-flex justify-content-center mt-3">
                    <label
                      for="staticEmail"
                      className="col-sm-3 col-form-label text-warning fw-bold"
                    >
                      Select An Audition
                    </label>
                    <div className="col-sm-8">
                      <select
                        onChange={handleChange}
                        className="form-select form-control reply-control text-black"
                        aria-label="Default select example"
                        id="audition_id"
                        name="audition_id"
                      >
                        <option value="0">--Select Audition--</option>
                        {events.map((event, index) => (
                          <option key={index} value={event?.id}>
                            {event?.title}
                          </option>
                        ))}
                      </select>
                      <span className="text-danger">
                        {errorList.audition_id}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="form-group row justify-content-center my-3">
                  <label
                    for="Audition"
                    className="col-sm-3 text-warning fw-bold"
                  >
                    Audition Title
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className="form-control reply-control"
                      id="Audition"
                      onChange={handleTitle}
                    />
                  </div>
                </div>
                <div className="form-group row justify-content-center my-3">
                  <label
                    for="Audition"
                    className="col-sm-3 text-warning fw-bold"
                  >
                    Sub Title
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className="form-control reply-control"
                      id="Audition"
                      onChange={handleSubTitle}
                    />
                  </div>
                </div>
                <div className="form-group row justify-content-center my-3">
                  <label
                    for="Audition"
                    className="col-sm-3 text-warning fw-bold"
                  >
                    Certificate Content
                  </label>
                  <div className="col-sm-8">
                    <CKEditor
                      data={convertedContent}
                      editor={ClassicEditor}
                      onChange={(event, editor) => {
                        setConvertedContent(editor.getData());
                      }}
                    />
                  </div>
                </div>
                <div className="form-group row justify-content-center my-3">
                  <label
                    for="Audition"
                    className="col-sm-3 fw-bold text-warning"
                  >
                    Company Logo
                  </label>
                  <div className="col-sm-8">
                    {file ? (
                      <img
                        src={file}
                        alt="..."
                        className="demo-preview-image img-fluid"
                      />
                    ) : (
                      ""
                    )}

                    <input
                      type="file"
                      name="company_logo"
                      id="company_logo"
                      className="inputfile w-25"
                      accept="image/jpg,image/jpeg, image/png"
                      onChange={(e) => {
                        handleImageChange(e.target.files);
                      }}
                    />

                    <label for="company_logo">
                      <i className="fas fa-cloud-upload-alt"></i> Upload Image
                    </label>
                  </div>
                </div>
                <div className="form-group row justify-content-center my-3">
                  <label
                    for="Audition"
                    className="col-sm-3 fw-bold text-warning"
                  >
                    Brand Logo
                  </label>
                  <div className="col-sm-8">
                    {logo ? (
                      <img
                        src={logo}
                        alt="..."
                        className="demo-preview-image img-fluid"
                      />
                    ) : (
                      ""
                    )}

                    <input
                      type="file"
                      name="brand_logo"
                      id="brand_logo"
                      className="inputfile w-25"
                      accept="image/jpg,image/jpeg, image/png"
                      onChange={(e) => {
                        handleBannerLogo(e.target.files);
                      }}
                    />

                    <label for="brand_logo">
                      <i className="fas fa-cloud-upload-alt"></i> Upload Image
                    </label>
                  </div>
                </div>
                <div className="form-group row justify-content-center my-3">
                  <label
                    for="Audition"
                    className="col-sm-3 fw-bold text-warning"
                  >
                    Frame
                  </label>
                  <div className="col-sm-8">
                    {frame ? (
                      <img
                        src={frame}
                        alt="..."
                        className="demo-preview-image img-fluid"
                      />
                    ) : (
                      ""
                    )}

                    <input
                      type="file"
                      name="frame"
                      id="frame"
                      className="inputfile w-25"
                      accept="image/jpg,image/jpeg, image/png"
                      onChange={(e) => handleFrame(e.target.files)}
                    />

                    <label for="frame">
                      <i className="fas fa-cloud-upload-alt"></i> Upload Image
                    </label>
                  </div>
                </div>
                <div className="form-group row justify-content-center my-3">
                  <label
                    for="Audition"
                    className="col-sm-3 text-warning fw-bold"
                  >
                    Fee
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="number"
                      className="form-control reply-control"
                      id="Audition"
                      onChange={(e) => setFee(e.target.value)}
                    />
                  </div>
                </div>
                <div className="form-group row  mt-5 mb-5">
                  <div className=" col-sm-3 mx-auto">
                    <div className="text-end">
                      <button
                        className="btn btnConfirm w-100 px-5 fw-bold"
                        type="sumit"
                        disabled={auditionId ? false : true}
                      >
                        {loader ? (
                          <>
                            <i className="fas fa-spinner fa-pulse"></i>&nbsp;
                          </>
                        ) : (
                          <></>
                        )}
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CreateCertificate;
